import { render, staticRenderFns } from "./RespostaFormularioList.vue?vue&type=template&id=4b9f58e3&scoped=true"
import script from "./RespostaFormularioList.vue?vue&type=script&lang=js"
export * from "./RespostaFormularioList.vue?vue&type=script&lang=js"
import style0 from "./RespostaFormularioList.vue?vue&type=style&index=0&id=4b9f58e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f58e3",
  null
  
)

export default component.exports